module.exports = __webpack_public_path__ + "static/media/not-found.20692034.svg";